import classNames from 'classnames';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import type { InfoTabPanelProps } from './InfoTabPanel.connect';
import { connectInfoTabPanel } from './InfoTabPanel.connect';

export const Component: FC<InfoTabPanelProps> = ({
  detailsContent,
  hasProductDump,
  productDumpContent,
  tabId,
  selectedTabIndex,
  selectTabQuoteDetail,
  selectTabProductDumpDetail,
}) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const selectFirstTab = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Quote details');
    selectTabQuoteDetail(tabId);
  }, [selectTabQuoteDetail, tabId, logAnalyticsCategory]);

  const selectProductDumpTab = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Product dump');
    selectTabProductDumpDetail(tabId);
  }, [selectTabProductDumpDetail, tabId, logAnalyticsCategory]);

  const { formatMessage } = useIntl();

  return (
    <div className="h-100 d-flex flex-column">
      <ul className="nav nav-compact-pills">
        <li className="nav-item" onClick={selectFirstTab}>
          <span
            className={classNames('nav-link ms-0', { active: selectedTabIndex === 'Details' })}
            data-e2e="quote-detail-panel"
          >
            {formatMessage({ id: 'quoteDetails.Tab.Details' })}
          </span>
        </li>

        {hasProductDump && (
          <li className="nav-item" onClick={hasProductDump ? selectProductDumpTab : undefined}>
            <span
              className={classNames('nav-link', { active: selectedTabIndex === 'ProductDump' })}
              data-e2e="product-dump-panel"
            >
              {formatMessage({ id: 'quoteDetails.Tab.Product.Dump' })}
            </span>
          </li>
        )}
      </ul>
      <div className="flex-grow-1 overflow-y-auto">
        {selectedTabIndex === 'Details' && detailsContent}
        {hasProductDump && selectedTabIndex === 'ProductDump' && productDumpContent}
      </div>
    </div>
  );
};

export const InfoTabPanel = connectInfoTabPanel(Component);

InfoTabPanel.displayName = 'InfoTabPanel';
